var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .add-button.a{fill:#acb5c0;opacity:0.5;}\n            .add-button.b,.add-button.c{fill:#fff;}\n            .add-button.b{stroke:#707070;opacity:0;}\n            .add-button.c{stroke:#fff;stroke-width:0.5px;}\n            .add-button.d{stroke:none;}\n            .add-button.e{fill:none;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.085 -0.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.085 0.335)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a add-button",
    width: 24,
    height: 24,
    rx: 12
  })), /*#__PURE__*/React.createElement("g", {
    className: "b add-button",
    transform: "translate(18.663 5.001) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d add-button",
    width: 13.997,
    height: 13.997
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e add-button",
    x: 0.5,
    y: 0.5,
    width: 12.997,
    height: 12.997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.915 7.082)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.089 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c add-button",
    d: "M4,3.6,7.115.48a.281.281,0,0,0-.4-.4L3.6,3.2.48.082a.281.281,0,0,0-.4.4L3.2,3.6.082,6.717a.281.281,0,0,0,.4.4L3.6,4,6.717,7.115a.281.281,0,1,0,.4-.4Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.6b2ecf7143ad79ae909bccbab0e042e4.svg";
export { ForwardRef as ReactComponent };